export const download = (document, url, fileName) => {
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  a.click();
};
